import { useForm as useFormHook } from "hooks";
import { BooleanSwitchValue } from "consts/general";
import type { IbanXsBank } from "features/openBanking/types";
import {
    IbanXSForm,
    type IbanXS
} from "./types";
import { BankingFormField, useBankingValidationSchema } from "../shared";

export const getInitialValues = (initialValues: Partial<IbanXsBank> = {}): IbanXS => ({
    [BankingFormField.BankGroup]: null,
    [BankingFormField.LogoUrl]: null,
    [BankingFormField.FullName]: '',
    [BankingFormField.BankId]: BooleanSwitchValue.Off,
    ...initialValues
});

export const useForm = (ibanXSForm: IbanXSForm) =>
    useFormHook({
        enableReinitialize: true,
        ...ibanXSForm,
        validateOnMount: true,
        validationSchema: useBankingValidationSchema()
    });
